import { useState } from 'react';
import toast from 'react-hot-toast';
import { forgotPasswordApi } from '~/api';
import { useBoolean } from '~/hooks/useBoolean';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

export default function useForgotPassword() {
  const [isLoading, loadingActions] = useBoolean();
  const [email, setEmail] = useState('');

  async function handleSubmit() {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error('Enter valid email!');
      return;
    }

    loadingActions.on();

    const promise = forgotPasswordApi({ email: trimmedEmail });
    const response = await apiResponseHandler<{}>(promise);

    if (response.type === ApiResponseEnum.Success) {
      toast.success('A password reset link has been sent to your email!');
    } else {
      toast.error(response.error.toString());
    }

    loadingActions.off();
  }

  return {
    isLoading,
    loadingActions,
    email,
    setEmail,
    handleSubmit,
  };
}
